/* eslint-disable react/prop-types */
import Box from '@mui/material/Box';
import Link from '@mui/material/Link';
import PropTypes from 'prop-types';
import React from 'react';
import GroupButton from '../GroupButton';
import useStyles from './styles';
import utils from 'util/utils';
import withBoundary from 'component/ErrorBoundary/withBoundary';
import { GroupsIcon, HomeIcon, StarIcon } from 'assets/images';

const Card = (props) => {
  const style = useStyles();
  const { group, text, room, user, home, onReturn, onEnd, onJoin } = props;
  return (
    <Box className={style.cardContainer}>
      <Box className={style.flexView} sx={{ justifyContent: 'space-between' }}>
        <Box className={style.flexView}>
          {home ? (
            <HomeIcon
              className={style.thumbCircle}
              style={{ padding: 0, width: '25px', height: '25px' }}
            />
          ) : (
            <GroupsIcon className={style.thumbCircle} />
          )}
          <Box className={style.bodyText}>{group.name}</Box>
        </Box>
        <Box className={style.flexView}>
          {text && (
            <Box className={style.chipView}>
              <Box className={{ alignSelf: 'center' }}>{text}</Box>
            </Box>
          )}
          <Box className={style.starCircle}>
            <StarIcon
              style={{ display: 'flex', width: '20px', height: '20px' }}
            />
          </Box>
        </Box>
      </Box>
      <Box className={style.groupView}>
        {room === group._id ? (
          <Box className="groupView">
            <Link style={{ textDecoration: 'none' }}>
              <GroupButton onClick={onReturn} yellow={true}>
                Return Now
              </GroupButton>
            </Link>
            {utils.isRemoteLogin(user) && (
              <GroupButton onClick={onEnd} red={true}>
                end session
              </GroupButton>
            )}
          </Box>
        ) : (
          <GroupButton green={true} onClick={onJoin}>
            Join Now
          </GroupButton>
        )}
      </Box>
    </Box>
  );
};

Card.propTypes = {
  name: PropTypes.string,
  onEnd: PropTypes.func,
  onJoin: PropTypes.func,
  onReturn: PropTypes.func,
  room: PropTypes.string,
  user: PropTypes.object,
  home: PropTypes.bool
};
export default React.memo(withBoundary(Card));
